import { render, staticRenderFns } from "./AddAggregator.vue?vue&type=template&id=6a578394"
import script from "./AddAggregator.vue?vue&type=script&lang=js"
export * from "./AddAggregator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports